import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { EditorChangeEvent } from '@progress/kendo-react-editor';

import { RecipientSelector } from './recipient-selector';
import { sendTeamsContent } from '../../../services/teams';
import HelpSupport from '../../../components/help-support';
import { sendGlobalContent } from '../../../services/games';
import { HtmlEditor } from '../../../components/editor/html-editor';
import {
  NotificationContent,
  NotificationContext
} from '../../../contexts/notification';

export const PushContentPage = () => {
  const { gameCode } = useParams();
  const [notification, setNotification] = React.useContext(NotificationContext);
  const [contentValue, setContentValue] = React.useState<string>('');
  const [selectedRecepient, setSelectedRecepient] = React.useState<{
    code: string;
    name: string;
  }>();

  const onHtmlChangeHandler = (event: EditorChangeEvent) => {
    setContentValue(event.html!);
  };

  const handleSubmit = async () => {
    if (gameCode && selectedRecepient) {
      if (selectedRecepient.code === '0') {
        await sendGlobalContent(gameCode, contentValue);
      } else {
        await sendTeamsContent(gameCode, selectedRecepient.code, contentValue);
      }

      const responseTeamNotification: NotificationContent = {
        icon: 'notifications',
        isHide: false,
        message: (
          <span>
            <strong>{`Content delivered to ${selectedRecepient.name}`}</strong>
          </span>
        )
      };
      const content: NotificationContent[] = notification.content;
      content.push(responseTeamNotification);
      setNotification({ ...notification, content });
    }
  };

  return (
    <div className={'d-flex flex-column gap-2 flex-grow-1 h-100'}>
      <div className={'d-flex justify-content-end'}>
        <HelpSupport
          title="Push content guide"
          url="https://forum.catalystglobal.com/t/4670"
        />
      </div>

      <div className={'row flex-grow-1 h-100 m-0 p-0 overflow-hidden'}>
        <div
          className={'col-2 d-flex flex-column h-100 overflow-auto p-0'}
          style={{
            border: '2px solid #efefef'
          }}>
          <RecipientSelector
            selectedRecepient={selectedRecepient}
            setSelectedRecepient={setSelectedRecepient}
          />
        </div>

        <div
          className={'col-10 d-flex flex-grow-1 flex-column gap-2 pr-0 pl-2'}>
          <div className={'d-flex justify-content-end'}>
            <Button
              id={'submit-push-content'}
              themeColor={'success'}
              className={'w-10'}
              onClick={handleSubmit}>
              Send
            </Button>
          </div>
          <div className={'mw-100'}>
            <HtmlEditor
              value={contentValue}
              handleHtmlChange={onHtmlChangeHandler}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
